import { makeActionCreator } from '../../../utilities'
import { PatientSearchConstants } from './patientSearch.constants'

export const setFirstName = makeActionCreator(PatientSearchConstants.SET_FIRST_NAME, 'firstName')
export const setLastName = makeActionCreator(PatientSearchConstants.SET_LAST_NAME, 'lastName')
export const setDOB = makeActionCreator(PatientSearchConstants.SET_DOB, 'dOB')
export const setSSN = makeActionCreator(PatientSearchConstants.SET_SSN, 'sSN')
export const getPatientSearchResults = makeActionCreator(PatientSearchConstants.GET_PATIENT_SEARCH_RESULTS)
export const setPatientSearchResults = makeActionCreator(
  PatientSearchConstants.SET_PATIENT_SEARCH_RESULTS,
  'searchResults'
)
export const getPatientRecord = makeActionCreator(PatientSearchConstants.GET_PATIENT_RECORD, 'selectedPtid')
export const setAreResultsLoading = makeActionCreator(
  PatientSearchConstants.SET_ARE_RESULTS_LOADING,
  'areResultsLoading'
)
export const setIsPatientDataLoading = makeActionCreator(
  PatientSearchConstants.SET_IS_PATIENT_DATA_LOADING,
  'isPatientDataLoading'
)
export const setShowImportDataConfirmationAlert = makeActionCreator(
  PatientSearchConstants.SET_SHOW_IMPORT_DATA_CONFIRMATION_ALERT,
  'showImportDataConfirmationAlert'
)
export const resetSearch = makeActionCreator(PatientSearchConstants.RESET_SEARCH)
export const resetSearchState = makeActionCreator(PatientSearchConstants.RESET_SEARCH_STATE)
export const setTotalAvailableResults = makeActionCreator(
  PatientSearchConstants.SET_TOTAL_AVAILABLE_RESULTS,
  'totalAvailableResults'
)
export const setTotalSearchResults = makeActionCreator(
  PatientSearchConstants.SET_TOTAL_SEARCH_RESULTS,
  'totalSearchResults'
)
export const setShowSharedServiceSearchResultsMessage = makeActionCreator(
  PatientSearchConstants.SET_SHOW_SHARED_SERVICE_SEARCH_RESULTS_MESSAGE,
  'showSharedServiceSearchResultsMessage'
)
export const setIsSearchImport = makeActionCreator(PatientSearchConstants.SET_IS_SEARCH_IMPORT, 'isSetSearchImport')
export const setPatientSearchData = makeActionCreator(PatientSearchConstants.SET_SEARCH_STATE, 'patientSearch')
export const getPatientSearchData = makeActionCreator(PatientSearchConstants.GET_PATIENT_SEARCH_DATA)
